// extracted by mini-css-extract-plugin
module.exports = {"icon":"SideNavLinks_icon__3MiMN","nav-links":"SideNavLinks_nav-links__2SvZm","active":"SideNavLinks_active__3XJvc"};